import React from "react";

interface Props {
  value: number;
  max?: number;
  color?: string;
  height?: number;
  showLabel?: boolean;
  animated?: boolean;
}

const ProgressBar: React.FC<Props> = ({
  value, max = 100, color = "#6366f1", height = 8, showLabel = false, animated = true,
}) => {
  const pct = Math.min(100, Math.round((value / max) * 100));
  return (
    <div className="w-full">
      <div className="w-full rounded-full bg-gray-100 overflow-hidden" style={{ height }}>
        <div
          className={`h-full rounded-full ${animated ? "transition-all duration-700" : ""}`}
          style={{ width: `${pct}%`, background: color }}
        />
      </div>
      {showLabel && (
        <p className="text-xs text-gray-500 mt-1 text-right">{pct}%</p>
      )}
    </div>
  );
};

export default ProgressBar;
